import { defineStore } from 'pinia';
import { ref } from 'vue';

const LAST_EXERCISE_STORAGE_KEY = 'macrotracker:last-exercise-type';

const hasLocalStorage = (): boolean =>
  typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

export const useExercisePreferencesStore = defineStore('exercisePreferences', () => {
  const lastExerciseTypeId = ref<string | null>(null);
  const isLoaded = ref(false);

  function load(): string | null {
    if (hasLocalStorage()) {
      lastExerciseTypeId.value = window.localStorage.getItem(LAST_EXERCISE_STORAGE_KEY);
    }
    isLoaded.value = true;
    return lastExerciseTypeId.value;
  }

  function setLastExerciseType(id: string): void {
    lastExerciseTypeId.value = id;
    if (hasLocalStorage()) {
      window.localStorage.setItem(LAST_EXERCISE_STORAGE_KEY, id);
    }
  }

  return {
    lastExerciseTypeId,
    isLoaded,
    load,
    setLastExerciseType,
  };
});
